import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

class ConfirmPayment extends Component {
	onSubmit = async () => {
		const { onOk } = this.props;
		onOk();
	};

	render() {
		const { type, price, user, period } = this.props;
		return (
			<div className="confirm-payment">
				<div className="confirm-info">
					<div className="confirm-info-type">{type}</div>
					<div className="confirm-info-amount">
						<div>
							<p>
								<b>{type}</b>
							</p>
							<p>{price} XHT</p>
							<p>{period}</p>
						</div>
						<div>
							<p>
								<b>Your Account Balance</b>
							</p>
							<p>{user.balance.xht_available} XHT</p>
							<p>
								<Link to="/credit">Make a XHT Deposit</Link>
								<Link to="/credit">Charge XHT Balance</Link>
							</p>
						</div>
					</div>
				</div>
				<div className="confirm-pay">{price}</div>
				<div className="confirm-check"></div>
				<Button block type="primary" onClick={this.onSubmit}>
					Confirm Payment
				</Button>
			</div>
		);
	}
}

export default ConfirmPayment;
